/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LieuFormationCapaciteFormativeDto
 */
export interface LieuFormationCapaciteFormativeDto {
    /**
     * 
     * @type {number}
     * @memberof LieuFormationCapaciteFormativeDto
     */
    capaciteFormative?: number;
    /**
     * 
     * @type {number}
     * @memberof LieuFormationCapaciteFormativeDto
     */
    capaciteFormativeSum?: number;
}

/**
 * Check if a given object implements the LieuFormationCapaciteFormativeDto interface.
 */
export function instanceOfLieuFormationCapaciteFormativeDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LieuFormationCapaciteFormativeDtoFromJSON(json: any): LieuFormationCapaciteFormativeDto {
    return LieuFormationCapaciteFormativeDtoFromJSONTyped(json, false);
}

export function LieuFormationCapaciteFormativeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LieuFormationCapaciteFormativeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'capaciteFormative': !exists(json, 'capaciteFormative') ? undefined : json['capaciteFormative'],
        'capaciteFormativeSum': !exists(json, 'capaciteFormativeSum') ? undefined : json['capaciteFormativeSum'],
    };
}

export function LieuFormationCapaciteFormativeDtoToJSON(value?: LieuFormationCapaciteFormativeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'capaciteFormative': value.capaciteFormative,
        'capaciteFormativeSum': value.capaciteFormativeSum,
    };
}

